/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  EmptyTreeInfo,
  GetAuthorizedOwnerGroupsParams,
  GetDetailsParams,
  GetProductionPermissionsParams,
  GetProductionSeasonsParams,
  GetProductionsInPeriodParams,
  GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams,
  GetProductionsInSeasonsParams,
  Int32PermissionTypeTuple,
  OwnerGroupDto,
  ProductionDetailsDto,
  ProductionDtoPagination,
  ProductionFieldTypeDto,
  ProductionTableRequest,
  SeasonFilterDto,
  SeasonFilterItem,
  SimpleProduction
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPaginatedProductionsUrl = () => {




  return `/api/Production/GetPaginatedProductions`
}

export const getPaginatedProductions = async (productionTableRequest: ProductionTableRequest, options?: Parameters<typeof customInstance>[1]): Promise<ProductionDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<ProductionDtoPagination>(getGetPaginatedProductionsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(productionTableRequest)
  }
);}





export const getGetPaginatedProductionsMutationKey = () => ['getPaginatedProductions'] as const;

export const getGetPaginatedProductionsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedProductions>>, TError,GetPaginatedProductionsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedProductions>>, TError,GetPaginatedProductionsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedProductionsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedProductions>>, GetPaginatedProductionsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedProductions(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedProductionsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedProductions>>>
    export type GetPaginatedProductionsMutationBody = BodyType<ProductionTableRequest>
    export type GetPaginatedProductionsMutationError = ErrorType<unknown>
    export type GetPaginatedProductionsMutationVariables = {data: BodyType<ProductionTableRequest>}

    export const useGetPaginatedProductions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedProductions>>, TError,GetPaginatedProductionsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedProductions>>,
        TError,
        GetPaginatedProductionsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedProductionsMutationOptions(options), queryClient);
    }
    export const getGetDetailsUrl = (params?: GetDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetDetails?${stringifiedParams}` : `/api/Production/GetDetails`
}

export const getDetails = async (params?: GetDetailsParams, options?: Parameters<typeof customInstance>[1]): Promise<ProductionDetailsDto> => {

  return customInstance<ProductionDetailsDto>(getGetDetailsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDetailsQueryKey = (params?: GetDetailsParams,) => {
    return [
    `/api/Production/GetDetails`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(params?: GetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetails>>> = ({ signal }) => getDetails(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getDetails>>>
export type GetDetailsQueryError = ErrorType<unknown>


export function useGetDetails<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDetails>>,
          TError,
          Awaited<ReturnType<typeof getDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetails<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDetails>>,
          TError,
          Awaited<ReturnType<typeof getDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetails<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDetails<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDetailsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(params?: GetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDetailsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDetails>>> = ({ signal }) => getDetails(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDetailsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDetails>>>
export type GetDetailsSuspenseQueryError = ErrorType<unknown>


export function useGetDetailsSuspense<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params: undefined |  GetDetailsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetailsSuspense<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDetailsSuspense<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDetailsSuspense<TData = Awaited<ReturnType<typeof getDetails>>, TError = ErrorType<unknown>>(
 params?: GetDetailsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDetails>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDetailsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuthorizedOwnerGroupsUrl = (params?: GetAuthorizedOwnerGroupsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetAuthorizedOwnerGroups?${stringifiedParams}` : `/api/Production/GetAuthorizedOwnerGroups`
}

export const getAuthorizedOwnerGroups = async (params?: GetAuthorizedOwnerGroupsParams, options?: Parameters<typeof customInstance>[1]): Promise<OwnerGroupDto[]> => {

  return customInstance<OwnerGroupDto[]>(getGetAuthorizedOwnerGroupsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAuthorizedOwnerGroupsQueryKey = (params?: GetAuthorizedOwnerGroupsParams,) => {
    return [
    `/api/Production/GetAuthorizedOwnerGroups`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAuthorizedOwnerGroupsQueryOptions = <TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthorizedOwnerGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>> = ({ signal }) => getAuthorizedOwnerGroups(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetAuthorizedOwnerGroupsQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>>
export type GetAuthorizedOwnerGroupsQueryError = ErrorType<unknown>


export function useGetAuthorizedOwnerGroups<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAuthorizedOwnerGroupsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>,
          TError,
          Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorizedOwnerGroups<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>,
          TError,
          Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorizedOwnerGroups<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthorizedOwnerGroups<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthorizedOwnerGroupsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetAuthorizedOwnerGroupsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAuthorizedOwnerGroupsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>> = ({ signal }) => getAuthorizedOwnerGroups(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetAuthorizedOwnerGroupsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>>
export type GetAuthorizedOwnerGroupsSuspenseQueryError = ErrorType<unknown>


export function useGetAuthorizedOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params: undefined |  GetAuthorizedOwnerGroupsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorizedOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetAuthorizedOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetAuthorizedOwnerGroupsSuspense<TData = Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError = ErrorType<unknown>>(
 params?: GetAuthorizedOwnerGroupsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAuthorizedOwnerGroups>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetAuthorizedOwnerGroupsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionSeasonsUrl = (params?: GetProductionSeasonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetProductionSeasons?${stringifiedParams}` : `/api/Production/GetProductionSeasons`
}

export const getProductionSeasons = async (params?: GetProductionSeasonsParams, options?: Parameters<typeof customInstance>[1]): Promise<SeasonFilterItem[]> => {

  return customInstance<SeasonFilterItem[]>(getGetProductionSeasonsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionSeasonsQueryKey = (params?: GetProductionSeasonsParams,) => {
    return [
    `/api/Production/GetProductionSeasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductionSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(params?: GetProductionSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionSeasonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionSeasons>>> = ({ signal }) => getProductionSeasons(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionSeasons>>>
export type GetProductionSeasonsQueryError = ErrorType<unknown>


export function useGetProductionSeasons<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionSeasonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionSeasons>>,
          TError,
          Awaited<ReturnType<typeof getProductionSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionSeasons<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionSeasons>>,
          TError,
          Awaited<ReturnType<typeof getProductionSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionSeasons<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionSeasons<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionSeasonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionSeasonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(params?: GetProductionSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionSeasonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionSeasons>>> = ({ signal }) => getProductionSeasons(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionSeasonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionSeasons>>>
export type GetProductionSeasonsSuspenseQueryError = ErrorType<unknown>


export function useGetProductionSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionSeasonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionSeasonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDefaultSeasonUrl = () => {




  return `/api/Production/GetDefaultSeason`
}

export const getDefaultSeason = async ( options?: Parameters<typeof customInstance>[1]): Promise<SeasonFilterDto> => {

  return customInstance<SeasonFilterDto>(getGetDefaultSeasonUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDefaultSeasonQueryKey = () => {
    return [
    `/api/Production/GetDefaultSeason`
    ] as const;
    }


export const getGetDefaultSeasonQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultSeasonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultSeason>>> = ({ signal }) => getDefaultSeason({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDefaultSeasonQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultSeason>>>
export type GetDefaultSeasonQueryError = ErrorType<unknown>


export function useGetDefaultSeason<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultSeason>>,
          TError,
          Awaited<ReturnType<typeof getDefaultSeason>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSeason<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDefaultSeason>>,
          TError,
          Awaited<ReturnType<typeof getDefaultSeason>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSeason<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDefaultSeason<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultSeasonQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetDefaultSeasonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDefaultSeasonQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDefaultSeason>>> = ({ signal }) => getDefaultSeason({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetDefaultSeasonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getDefaultSeason>>>
export type GetDefaultSeasonSuspenseQueryError = ErrorType<unknown>


export function useGetDefaultSeasonSuspense<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSeasonSuspense<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDefaultSeasonSuspense<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetDefaultSeasonSuspense<TData = Awaited<ReturnType<typeof getDefaultSeason>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getDefaultSeason>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDefaultSeasonSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInPeriodUrl = (params?: GetProductionsInPeriodParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetProductionsInPeriod?${stringifiedParams}` : `/api/Production/GetProductionsInPeriod`
}

export const getProductionsInPeriod = async (params?: GetProductionsInPeriodParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleProduction[]> => {

  return customInstance<SimpleProduction[]>(getGetProductionsInPeriodUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionsInPeriodQueryKey = (params?: GetProductionsInPeriodParams,) => {
    return [
    `/api/Production/GetProductionsInPeriod`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductionsInPeriodQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInPeriodQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInPeriod>>> = ({ signal }) => getProductionsInPeriod(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionsInPeriodQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInPeriod>>>
export type GetProductionsInPeriodQueryError = ErrorType<unknown>


export function useGetProductionsInPeriod<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInPeriodParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInPeriod>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInPeriod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriod<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInPeriod>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInPeriod>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriod<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInPeriod<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInPeriodQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInPeriodSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInPeriodQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInPeriod>>> = ({ signal }) => getProductionsInPeriod(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionsInPeriodSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInPeriod>>>
export type GetProductionsInPeriodSuspenseQueryError = ErrorType<unknown>


export function useGetProductionsInPeriodSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInPeriodParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInPeriodSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriod>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriod>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInPeriodSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInPeriodWithDepartmentCollectiveBasicCastUrl = (params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetProductionsInPeriodWithDepartmentCollectiveBasicCast?${stringifiedParams}` : `/api/Production/GetProductionsInPeriodWithDepartmentCollectiveBasicCast`
}

export const getProductionsInPeriodWithDepartmentCollectiveBasicCast = async (params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleProduction[]> => {

  return customInstance<SimpleProduction[]>(getGetProductionsInPeriodWithDepartmentCollectiveBasicCastUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryKey = (params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams,) => {
    return [
    `/api/Production/GetProductionsInPeriodWithDepartmentCollectiveBasicCast`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>> = ({ signal }) => getProductionsInPeriodWithDepartmentCollectiveBasicCast(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>>
export type GetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryError = ErrorType<unknown>


export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCast<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCast<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCast<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCast<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInPeriodWithDepartmentCollectiveBasicCastQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>> = ({ signal }) => getProductionsInPeriodWithDepartmentCollectiveBasicCast(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>>
export type GetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspenseQueryError = ErrorType<unknown>


export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspense<TData = Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInPeriodWithDepartmentCollectiveBasicCastParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInPeriodWithDepartmentCollectiveBasicCast>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInPeriodWithDepartmentCollectiveBasicCastSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionFieldTypesForTableUrl = () => {




  return `/api/Production/GetProductionFieldTypesForTable`
}

export const getProductionFieldTypesForTable = async ( options?: Parameters<typeof customInstance>[1]): Promise<ProductionFieldTypeDto[]> => {

  return customInstance<ProductionFieldTypeDto[]>(getGetProductionFieldTypesForTableUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionFieldTypesForTableQueryKey = () => {
    return [
    `/api/Production/GetProductionFieldTypesForTable`
    ] as const;
    }


export const getGetProductionFieldTypesForTableQueryOptions = <TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionFieldTypesForTableQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>> = ({ signal }) => getProductionFieldTypesForTable({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionFieldTypesForTableQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>>
export type GetProductionFieldTypesForTableQueryError = ErrorType<unknown>


export function useGetProductionFieldTypesForTable<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionFieldTypesForTable>>,
          TError,
          Awaited<ReturnType<typeof getProductionFieldTypesForTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionFieldTypesForTable<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionFieldTypesForTable>>,
          TError,
          Awaited<ReturnType<typeof getProductionFieldTypesForTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionFieldTypesForTable<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionFieldTypesForTable<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionFieldTypesForTableQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionFieldTypesForTableSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionFieldTypesForTableQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>> = ({ signal }) => getProductionFieldTypesForTable({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionFieldTypesForTableSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>>
export type GetProductionFieldTypesForTableSuspenseQueryError = ErrorType<unknown>


export function useGetProductionFieldTypesForTableSuspense<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionFieldTypesForTableSuspense<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionFieldTypesForTableSuspense<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionFieldTypesForTableSuspense<TData = Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionFieldTypesForTable>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionFieldTypesForTableSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionPermissionsUrl = (params?: GetProductionPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["productionIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetProductionPermissions?${stringifiedParams}` : `/api/Production/GetProductionPermissions`
}

export const getProductionPermissions = async (params?: GetProductionPermissionsParams, options?: Parameters<typeof customInstance>[1]): Promise<Int32PermissionTypeTuple[]> => {

  return customInstance<Int32PermissionTypeTuple[]>(getGetProductionPermissionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionPermissionsQueryKey = (params?: GetProductionPermissionsParams,) => {
    return [
    `/api/Production/GetProductionPermissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductionPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(params?: GetProductionPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionPermissions>>> = ({ signal }) => getProductionPermissions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionPermissions>>>
export type GetProductionPermissionsQueryError = ErrorType<unknown>


export function useGetProductionPermissions<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionPermissions>>,
          TError,
          Awaited<ReturnType<typeof getProductionPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionPermissions<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionPermissions>>,
          TError,
          Awaited<ReturnType<typeof getProductionPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionPermissions<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionPermissions<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionPermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(params?: GetProductionPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionPermissions>>> = ({ signal }) => getProductionPermissions(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionPermissions>>>
export type GetProductionPermissionsSuspenseQueryError = ErrorType<unknown>


export function useGetProductionPermissionsSuspense<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionPermissionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionPermissionsSuspense<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionPermissionsSuspense<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionPermissionsSuspense<TData = Awaited<ReturnType<typeof getProductionPermissions>>, TError = ErrorType<unknown>>(
 params?: GetProductionPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionPermissionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInSeasonsUrl = (params?: GetProductionsInSeasonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["seasonIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Production/GetProductionsInSeasons?${stringifiedParams}` : `/api/Production/GetProductionsInSeasons`
}

export const getProductionsInSeasons = async (params?: GetProductionsInSeasonsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimpleProduction[]> => {

  return customInstance<SimpleProduction[]>(getGetProductionsInSeasonsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionsInSeasonsQueryKey = (params?: GetProductionsInSeasonsParams,) => {
    return [
    `/api/Production/GetProductionsInSeasons`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetProductionsInSeasonsQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInSeasonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInSeasons>>> = ({ signal }) => getProductionsInSeasons(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionsInSeasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInSeasons>>>
export type GetProductionsInSeasonsQueryError = ErrorType<unknown>


export function useGetProductionsInSeasons<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInSeasonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInSeasons>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInSeasons<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionsInSeasons>>,
          TError,
          Awaited<ReturnType<typeof getProductionsInSeasons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInSeasons<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInSeasons<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInSeasonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionsInSeasonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionsInSeasonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionsInSeasons>>> = ({ signal }) => getProductionsInSeasons(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionsInSeasonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionsInSeasons>>>
export type GetProductionsInSeasonsSuspenseQueryError = ErrorType<unknown>


export function useGetProductionsInSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetProductionsInSeasonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionsInSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionsInSeasonsSuspense<TData = Awaited<ReturnType<typeof getProductionsInSeasons>>, TError = ErrorType<unknown>>(
 params?: GetProductionsInSeasonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionsInSeasons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionsInSeasonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionTreeUrl = () => {




  return `/api/Production/GetProductionTree`
}

export const getProductionTree = async ( options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetProductionTreeUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetProductionTreeQueryKey = () => {
    return [
    `/api/Production/GetProductionTree`
    ] as const;
    }


export const getGetProductionTreeQueryOptions = <TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionTreeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionTree>>> = ({ signal }) => getProductionTree({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetProductionTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionTree>>>
export type GetProductionTreeQueryError = ErrorType<unknown>


export function useGetProductionTree<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionTree>>,
          TError,
          Awaited<ReturnType<typeof getProductionTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionTree<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getProductionTree>>,
          TError,
          Awaited<ReturnType<typeof getProductionTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionTree<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionTree<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionTreeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetProductionTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetProductionTreeQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getProductionTree>>> = ({ signal }) => getProductionTree({ signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetProductionTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getProductionTree>>>
export type GetProductionTreeSuspenseQueryError = ErrorType<unknown>


export function useGetProductionTreeSuspense<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionTreeSuspense<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetProductionTreeSuspense<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetProductionTreeSuspense<TData = Awaited<ReturnType<typeof getProductionTree>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getProductionTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetProductionTreeSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






